const translations = {
    noDronesFound: 'No drones found',
    search: 'Search drones'
};

export default translations;
